import React from "react";
import { forwardRef, Image, ImageProps } from "@chakra-ui/react";

export const ImageComponent = forwardRef(
  (props: ImageProps, ref: React.ForwardedRef<HTMLImageElement>) => (
    <Image ref={ref} {...props} />
  ),
);
